import { SEARCHBOX_HIDE, SEARCHBOX_SEARCH_REP, SEARCHBOX_SEARCH_REP_CLEAR, SEARCHBOX_SHOW } from '../constants/searchTypes';

export function searchBoxShow() {
  return {
    type: SEARCHBOX_SHOW
  };
}

export function searchBoxHide() {
  return {
    type: SEARCHBOX_HIDE
  };
}

export function searchRep(query) {
  return {
    type: SEARCHBOX_SEARCH_REP,
    payload: { query }
  };
}

export function searchRepClear() {
  return {
    type: SEARCHBOX_SEARCH_REP_CLEAR
  };
}



// WEBPACK FOOTER //
// ./app/actions/searchActions.js